<template>
    <v-container>
        <v-layout column class="card">
            <v-label><h4>Expiração de Leads</h4></v-label>
            <v-form ref="form">
                <v-layout wrap mt-5>
                    <v-flex v-for="(item,i) in items" :key="i">
                        <div class="mr-5">
                            <v-label>{{item.desc}} (em horas)</v-label>
                            <v-text-field mask="####"
                                          :rules="[rules.required,rules.notzero]"
                                          v-model="item.horas"
                                          validate-on-blur
                                          flat solo>
                            </v-text-field>
                        </div>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-layout mt-3>
                <v-flex xs12 sm4 lg3 xl2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import { LeadStatus } from '../constantes'
import { alert, error, sleep } from '../plugins/helpers'
import { mapState } from 'vuex'

export default {
  data: () => ({
    items: []
  }),
  computed: {
    rules: () => Rules,
    ...mapState(['id_unidade_negocio'])
  },
  methods: {
    salvar () {
      const form = this.$refs.form

      if (form.validate()) {
        this.$http.post('/admin/configuracoes/leadsla', {
          items: this.items
        }).then(() => {
          alert('Expiração de lead salva com sucesso!')
        }).catch(err => {
          error(err, 'Não foi possível salvar as informações.')
        })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    },
    carregarSla (unidade) {
      this.$http.get(`/admin/configuracoes/leadsla`, { params: { id_unidade_negocio: unidade } }).then(res => {
        this.items = [LeadStatus.qualificar, LeadStatus.qualificado, LeadStatus.em_negociacao, LeadStatus.com_agendamento].map((ls) => ({ ...ls, horas: res.data.items[ls.status], id_unidade_negocio: unidade }))
      }).catch(err => {
        error(err, 'Não foi possível recuperar as informações.')
      })
    }
  },
  watch: {
    id_unidade_negocio () {
      this.carregarSla(this.id_unidade_negocio)
    }
  },
  mounted () {
    this.carregarSla(this.id_unidade_negocio)
  }
}
</script>

<style scoped>

</style>
